/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SymbolFundamentalsRatiosDto
 */
export interface SymbolFundamentalsRatiosDto {
    /**
     * 
     * @type {string}
     * @memberof SymbolFundamentalsRatiosDto
     */
    symbolId: string;
    /**
     * 
     * @type {number}
     * @memberof SymbolFundamentalsRatiosDto
     */
    marketCapitalization: number | null;
    /**
     * 
     * @type {number}
     * @memberof SymbolFundamentalsRatiosDto
     */
    enterpriseValue: number | null;
    /**
     * 
     * @type {number}
     * @memberof SymbolFundamentalsRatiosDto
     */
    peRatio: number | null;
    /**
     * 
     * @type {number}
     * @memberof SymbolFundamentalsRatiosDto
     */
    forwardPe: number | null;
    /**
     * 
     * @type {number}
     * @memberof SymbolFundamentalsRatiosDto
     */
    pegRatio: number | null;
    /**
     * 
     * @type {number}
     * @memberof SymbolFundamentalsRatiosDto
     */
    priceToSales: number | null;
    /**
     * 
     * @type {number}
     * @memberof SymbolFundamentalsRatiosDto
     */
    priceToBook: number | null;
    /**
     * 
     * @type {number}
     * @memberof SymbolFundamentalsRatiosDto
     */
    evEbitda: number | null;
    /**
     * 
     * @type {number}
     * @memberof SymbolFundamentalsRatiosDto
     */
    enterpriseValueRevenue: number | null;
    /**
     * 
     * @type {number}
     * @memberof SymbolFundamentalsRatiosDto
     */
    roe: number | null;
    /**
     * 
     * @type {number}
     * @memberof SymbolFundamentalsRatiosDto
     */
    marginTTM: number | null;
    /**
     * 
     * @type {number}
     * @memberof SymbolFundamentalsRatiosDto
     */
    dividendYield: number | null;
    /**
     * 
     * @type {number}
     * @memberof SymbolFundamentalsRatiosDto
     */
    dividendPayoutRatio: number | null;
    /**
     * 
     * @type {number}
     * @memberof SymbolFundamentalsRatiosDto
     */
    fcfYield: number | null;
    /**
     * 
     * @type {number}
     * @memberof SymbolFundamentalsRatiosDto
     */
    priceToFreeCashFlow: number | null;
    /**
     * 
     * @type {number}
     * @memberof SymbolFundamentalsRatiosDto
     */
    debtToEquity: number | null;
    /**
     * 
     * @type {number}
     * @memberof SymbolFundamentalsRatiosDto
     */
    priceTangibleBook: number | null;
    /**
     * 
     * @type {number}
     * @memberof SymbolFundamentalsRatiosDto
     */
    roic: number | null;
    /**
     * 
     * @type {number}
     * @memberof SymbolFundamentalsRatiosDto
     */
    roce: number | null;
    /**
     * 
     * @type {number}
     * @memberof SymbolFundamentalsRatiosDto
     */
    fcfPerShare: number | null;
    /**
     * 
     * @type {number}
     * @memberof SymbolFundamentalsRatiosDto
     */
    sbcPerShare: number | null;
    /**
     * 
     * @type {number}
     * @memberof SymbolFundamentalsRatiosDto
     */
    sbcImpact: number | null;
    /**
     * 
     * @type {number}
     * @memberof SymbolFundamentalsRatiosDto
     */
    freeCashFlow: number | null;
    /**
     * 
     * @type {number}
     * @memberof SymbolFundamentalsRatiosDto
     */
    cashAndShortTermInvestments: number | null;
    /**
     * 
     * @type {number}
     * @memberof SymbolFundamentalsRatiosDto
     */
    totalDebt: number | null;
    /**
     * 
     * @type {number}
     * @memberof SymbolFundamentalsRatiosDto
     */
    sharesOutstanding: number | null;
    /**
     * 
     * @type {number}
     * @memberof SymbolFundamentalsRatiosDto
     */
    dilutedEpsTTM: number | null;
}

export function SymbolFundamentalsRatiosDtoFromJSON(json: any): SymbolFundamentalsRatiosDto {
    return SymbolFundamentalsRatiosDtoFromJSONTyped(json, false);
}

export function SymbolFundamentalsRatiosDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SymbolFundamentalsRatiosDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'symbolId': json['symbolId'],
        'marketCapitalization': json['marketCapitalization'],
        'enterpriseValue': json['enterpriseValue'],
        'peRatio': json['peRatio'],
        'forwardPe': json['forwardPe'],
        'pegRatio': json['pegRatio'],
        'priceToSales': json['priceToSales'],
        'priceToBook': json['priceToBook'],
        'evEbitda': json['evEbitda'],
        'enterpriseValueRevenue': json['enterpriseValueRevenue'],
        'roe': json['roe'],
        'marginTTM': json['marginTTM'],
        'dividendYield': json['dividendYield'],
        'dividendPayoutRatio': json['dividendPayoutRatio'],
        'fcfYield': json['fcfYield'],
        'priceToFreeCashFlow': json['priceToFreeCashFlow'],
        'debtToEquity': json['debtToEquity'],
        'priceTangibleBook': json['priceTangibleBook'],
        'roic': json['roic'],
        'roce': json['roce'],
        'fcfPerShare': json['fcfPerShare'],
        'sbcPerShare': json['sbcPerShare'],
        'sbcImpact': json['sbcImpact'],
        'freeCashFlow': json['freeCashFlow'],
        'cashAndShortTermInvestments': json['cashAndShortTermInvestments'],
        'totalDebt': json['totalDebt'],
        'sharesOutstanding': json['sharesOutstanding'],
        'dilutedEpsTTM': json['dilutedEpsTTM'],
    };
}

export function SymbolFundamentalsRatiosDtoToJSON(value?: SymbolFundamentalsRatiosDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'symbolId': value.symbolId,
        'marketCapitalization': value.marketCapitalization,
        'enterpriseValue': value.enterpriseValue,
        'peRatio': value.peRatio,
        'forwardPe': value.forwardPe,
        'pegRatio': value.pegRatio,
        'priceToSales': value.priceToSales,
        'priceToBook': value.priceToBook,
        'evEbitda': value.evEbitda,
        'enterpriseValueRevenue': value.enterpriseValueRevenue,
        'roe': value.roe,
        'marginTTM': value.marginTTM,
        'dividendYield': value.dividendYield,
        'dividendPayoutRatio': value.dividendPayoutRatio,
        'fcfYield': value.fcfYield,
        'priceToFreeCashFlow': value.priceToFreeCashFlow,
        'debtToEquity': value.debtToEquity,
        'priceTangibleBook': value.priceTangibleBook,
        'roic': value.roic,
        'roce': value.roce,
        'fcfPerShare': value.fcfPerShare,
        'sbcPerShare': value.sbcPerShare,
        'sbcImpact': value.sbcImpact,
        'freeCashFlow': value.freeCashFlow,
        'cashAndShortTermInvestments': value.cashAndShortTermInvestments,
        'totalDebt': value.totalDebt,
        'sharesOutstanding': value.sharesOutstanding,
        'dilutedEpsTTM': value.dilutedEpsTTM,
    };
}

